module.exports = __webpack_public_path__ + "img/Visa_Brandmark_Blue_Black.0237f633.png";